import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PdfDownloadService {

  downloadBase64(pdfContent: string, filename: string): void {
    try {
      const byteCharacters = atob(pdfContent);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || 'rapport.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('[PdfDownloadService] Failed to download PDF', e);
      throw e;
    }
  }

  downloadFromJsonResponse(response: { pdf_content?: string; filename?: string }): void {
    if (!response?.pdf_content) {
      throw new Error('No PDF content in response');
    }
    this.downloadBase64(response.pdf_content, response.filename || 'rapport.pdf');
  }
}
